@if (initialMask) {
  <div class="tidy-phone-field">
    @if (label) {
      <tidy-text
        [id]="labelId"
        [fieldLabel]="label"
        class="field-label"
        [class.error]="!disableElement && !form?.valid && submitted" />
    }

    <div
      class="input-container"
      [class.invalid-field]="!disableElement && !form?.valid && submitted"
      [class.no-border]="noBorder"
      [class.focused]="focused">

      @if (icon) {
        <tidy-image [src]="icon" class="input-icon no-right-margin" />
      }

      <input
        appBlockCopyPaste
        [id]="resolvedInputId"
        [attr.aria-labelledby]="label ? labelId : null"
        [attr.aria-label]="label ? null : (helperText || null)"
        [imask]="maskConfig"
        [unmask]="true"
        #phoneInput
        [disabled]="disableElement"
        [value]="phoneValue"
        [placeholder]="helperText || ''"
        (keydown)="changeTouch()"
        (input)="onInputChange()"
        formnovalidate="formnovalidate"
        [type]="type"
        [attr.inputMode]="inputMode"
        (focus)="setFocused(true); checkFocused()"
        (focusout)="setFocused(false); checkFocusedout($event)"
        [autocomplete]="autoComplete" />
    </div>

    @if (submitted && !disableElement && !form?.valid) {
      <tidy-error-message [text]="errorMessage" />
    }
  </div>
}
